define("shared/components/shared/wizard/previous-button", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#unless @isFirstSlide}}
    {{#if (has-block)}}
      <Shared::Ui::Button
        @onClick={{action "previousSlide"}}
        @variant="none"
        class={{if @buttonClass @buttonClass this.defaultClass}}
      >
        {{yield}}
      </Shared::Ui::Button>
    {{else}}
      <Shared::Ui::Button
        @onClick={{action "previousSlide"}}
        @text={{this.buttonText}}
        @variant="none"
        class={{if @buttonClass @buttonClass this.defaultClass}}
      />
    {{/if}}
  {{/unless}}
  */
  {
    "id": "omX0416O",
    "block": "[[[41,[51,[30,1]],[[[41,[48,[30,3]],[[[1,\"    \"],[8,[39,3],[[16,0,[52,[30,2],[30,2],[30,0,[\"defaultClass\"]]]]],[[\"@onClick\",\"@variant\"],[[28,[37,4],[[30,0],\"previousSlide\"],null],\"none\"]],[[\"default\"],[[[[1,\"\\n      \"],[18,3,null],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"    \"],[8,[39,3],[[16,0,[52,[30,2],[30,2],[30,0,[\"defaultClass\"]]]]],[[\"@onClick\",\"@text\",\"@variant\"],[[28,[37,4],[[30,0],\"previousSlide\"],null],[30,0,[\"buttonText\"]],\"none\"]],null],[1,\"\\n\"]],[]]]],[]],null]],[\"@isFirstSlide\",\"@buttonClass\",\"&default\"],false,[\"unless\",\"if\",\"has-block\",\"shared/ui/button\",\"action\",\"yield\"]]",
    "moduleName": "shared/components/shared/wizard/previous-button.hbs",
    "isStrictMode": false
  });
  let PreviousButtonComponent = _exports.default = (_class = class PreviousButtonComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "intl", _descriptor, this);
      _defineProperty(this, "defaultClass", 'o--btn o--btn--outline u--p__lr__lg u--float--left qa--slide_previous');
    }
    get defaultButtonText() {
      return this.intl.t('shared_words.back');
    }
    get buttonText() {
      return this.args.text ? this.args.text : this.defaultButtonText;
    }
    previousSlide() {
      this.args.onClick?.();
      this.args.previousSlide();
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "previousSlide", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "previousSlide"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PreviousButtonComponent);
});